import React from 'react';
import { Dialog, DialogTitle, IconButton, Grid, Divider, Box, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface GlobalPopUpProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    maxWidth?: any;
    showCloseIcon?: boolean;
    children: React.ReactNode;
    fullWidth?: boolean;
    spacing?: number;
    className?: string;
    paperProps?: object;
    sx?: object;
    flagDivider?: any
    titleClassName?: string;
}

const GlobalPopUp: React.FC<GlobalPopUpProps> = ({
    open,
    onClose,
    title,
    maxWidth = '',
    showCloseIcon = true,
    children,
    fullWidth = true,
    spacing = 2,
    className,
    paperProps,
    sx,
    flagDivider,
    titleClassName
}) => {
    const defaultSx = {
        '& .MuiPaper-root': {
            borderRadius: '5px',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '90vh',
            gap: '10px',
            padding: '20px 30px'
        },
        ...sx
    };

    return (
        <Dialog
            open={open}
            onClose={(_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            className={className}
            PaperProps={paperProps}
            sx={defaultSx}
        >
            {/* Sticky Header */}
            {(title || showCloseIcon) && (
                <Box
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                    }}
                >
                    <DialogTitle
                        className={titleClassName}
                        sx={{
                            padding: 0,
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 1,
                            position: 'relative',
                            color: "#0A1E3C",
                            fontWeight: "700",
                            paddingBottom: flagDivider ? '8px' : undefined,
                        }}
                    >
                        {title}
                        {showCloseIcon && (
                            <IconButton
                                onClick={onClose}
                                sx={{
                                    color: '#99A1AF'
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </DialogTitle>
                    {flagDivider && (
                        <Divider
                            sx={{
                                opacity: 0.8,
                                borderColor: "#B7B7B7",
                                height: "1px",
                                width: "100%",
                                margin: "0 auto"
                            }}
                        />
                    )}
                </Box>
            )}

            {/* Scrollable Content */}
            <DialogContent
                sx={{
                    flex: 1,
                    overflow: 'auto',
                    padding: 0, // Remove default padding to let Grid handle it
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={spacing}
                    sx={{
                        margin: 0,
                        width: '100%',
                        minHeight: '100%'
                    }}
                >
                    {children}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default GlobalPopUp;